module.exports = __webpack_public_path__ + "9d870f6673addfbed47ecb610e90857d.pdf";